module.exports = __webpack_public_path__ + "static/media/es.7b6d1881.svg";